import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useSiteSettings, useTours } from "@/lib/siteData";
import { ExperienceInfo } from "@/components/booking/ExperienceInfo";
import { BookingFlow } from "@/components/booking/BookingFlow";
import { BookingConfirmation } from "@/components/booking/BookingConfirmation";
import { panel } from "@/components/booking/ui";

function useSeo(tour) {
    useEffect(() => {
        if (!tour) return undefined;
        const prev = document.title;
        const meta = document.querySelector('meta[name="description"]');
        const prevDesc = meta?.getAttribute("content");
        document.title = tour.seo_title || `${tour.title} | Jetski Paradise Ubatuba`;
        meta?.setAttribute("content", tour.seo_description || tour.description || "");
        return () => {
            document.title = prev;
            if (meta && prevDesc != null) meta.setAttribute("content", prevDesc);
        };
    }, [tour]);
}

export default function BookingPage() {
    const { tourId } = useParams();
    const [params] = useSearchParams();
    const tours = useTours();
    const settings = useSiteSettings();
    const tour = tours.find((t) => String(t.id) === tourId || t.slug === tourId);
    const [done, setDone] = useState(null);
    useSeo(tour);

    return (
        <main className="grain min-h-screen bg-ocean px-3 pb-24 pt-6 font-body text-ink sm:px-5 sm:pb-20 sm:pt-12">
            <div className="mx-auto max-w-6xl min-w-0">
                <Link to="/" data-testid="booking-back" className="font-mono2 text-xs uppercase tracking-[0.2em] text-neon-cyan">← Voltar ao site</Link>
                {!tour ? (
                    <div className={panel + " mt-8"} data-testid="experience-not-found">
                        <p>Experiência não encontrada ou indisponível.</p>
                        <Link to="/" className="mt-5 inline-block text-neon-cyan">Voltar ao catálogo de jet ski →</Link>
                    </div>
                ) : (
                    <>
                        <ExperienceInfo tour={tour} />
                        {done ? (
                            <BookingConfirmation data={done.data} customer={done.customer} tour={tour} settings={settings} />
                        ) : (
                            <BookingFlow key={tour.id} tour={tour} settings={settings}
                                initial={{ date: params.get("data") || "", guests: Number(params.get("pessoas")) || 1 }}
                                onDone={(data, customer) => { setDone({ data, customer }); window.scrollTo({ top: 0, behavior: "smooth" }); }} />
                        )}
                    </>
                )}
            </div>
        </main>
    );
}
